module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [(_vm.isDeleteAction) ? _c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Confirmação de remoção do produto")]) : _c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Confirmação de remoção do vínculo do anúncio")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), (_vm.isDeleteAction) ? [_c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n        O produto será excluído do PlaceMarket e do Mercado Livre. Esta ação não pode ser desfeita.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n        Tem certeza de que deseja remover o produto " + _vm._s(_vm.productInText) + " do PlaceMarket e do Mercado Livre?\n      ")])] : [_c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n        O produto sai só do PlaceMarket. O anúncio continua no Mercado Livre, sem alteração, e pode ser migrado para o PlaceMarket de novo.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n        Tem certeza de que deseja remover o vínculo do anúncio " + _vm._s(_vm.productInText) + " com o PlaceMarket?\n      ")])], _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Sim")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241dff2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/ModalProductRemoveConfirmation.vue
// module id = 2982
// module chunks = 0